/* eslint-disable import/prefer-default-export */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { notification } from '../components';

export const useFetch = () => {
  const [blogs, setBlogs] = useState();
  // const [events , setEvents] = useState()
  const [events, setEvents] = useState();
  const [testimonials, setTestimonials] = useState();

  const getEvents = () => {
    const myHeaders = new Headers();
    // myHeaders.append('Access-Control-Request-Headers', 'message/http');
    // myHeaders.append('Access-Control-Allow-Origin', '*');
    myHeaders.append('Cookie', 'PHPSESSID=c8d608e62584937a1b7d242a727fb4aa');

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow',
    };

    fetch('https://thesynergyworks.com/?json=get_posts&post_type=events', requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setEvents(result?.posts);
      })
      .catch((error) => console.log('error', error));
  };

  const getBlogs = () => {
    const myHeaders = new Headers();
    // myHeaders.append('Access-Control-Request-Headers', 'message/http');
    // myHeaders.append('Access-Control-Allow-Origin', '*');
    myHeaders.append('Cookie', 'PHPSESSID=c8d608e62584937a1b7d242a727fb4aa');

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow',
    };

    fetch('https://thesynergyworks.com/?json=get_posts&post_type=post', requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setBlogs(result?.posts);
      })
      .catch((error) => console.log('error', error));
  };

  const getTestimonials = () => {
    const myHeaders = new Headers();
    // myHeaders.append('Access-Control-Request-Headers', 'message/http');
    // myHeaders.append('Access-Control-Allow-Origin', '*');
    myHeaders.append('Cookie', 'PHPSESSID=c8d608e62584937a1b7d242a727fb4aa');

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow',
    };

    fetch('https://thesynergyworks.com/?json=get_posts&post_type=client-testimonial', requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setTestimonials(result?.posts);
      })
      .catch((error) => console.log('error', error));
  };

  useEffect(() => {
    getBlogs();
    getEvents();
    getTestimonials();
  }, []);

  return { blogs, events, testimonials };
};

export const useContact = () => {
  const [isLoading, setIsLoading] = useState(false);
  // const [events , setEvents] = useState()
  const [dataToSend, setDataToSend] = useState();

  const submitContactInfo = (body, resetForm) => {
    setIsLoading(true);

    const myHeaders = new Headers();
    myHeaders.append('Cookie', 'PHPSESSID=314dfb3bb85d70cbc316f9ffe59a4970');

    const formData = new FormData();

    Object.keys(body).forEach((key) => formData.append(key, body[key]));

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formData,
      redirect: 'manual',
    };

    // fetch('https://thesynergyworks.com/wp-json/contact-form-7/v1/contact-forms/16207/feedback', requestOptions)
    fetch('https://thesynergyworks.com/wp-json/custom-forminator/v1/submit/32676', requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.status === 'spam') {
          notification({
            type: 'error',
            title: 'Something went wrong!',
            description: result?.message || 'Unable to submit contact request at the moment. Please try again later.',
          });
        }
        notification({
          type: 'success',
          title: 'Contact information submitted!',
          description: result?.message || 'Someone from our team will contact you soon.',
        });
        resetForm();
      })
      .catch((error) => {
        console.log('error', error);
        notification({
          type: 'error',
          title: 'Unable to submit Info!',
          description: 'Please try again later.',
        });
      })
      .finally(() => setIsLoading(false));
  };

  return { isLoading, submitContactInfo };
};

export const useNewsLetter = () => {
  const [isLoading, setIsLoading] = useState(false);
  // const [events , setEvents] = useState()
  const [dataToSend, setDataToSend] = useState();

  const submitContactInfo = (body) => {
    setIsLoading(true);

    const myHeaders = new Headers();
    myHeaders.append('Cookie', 'PHPSESSID=314dfb3bb85d70cbc316f9ffe59a4970');

    const raw = new FormData();

    Object.keys(body).forEach((key) => raw.append(key, body[key]));

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'manual',
    };

    // fetch('https://thesynergyworks.com/wp-json/contact-form-7/v1/contact-forms/17609/feedback', requestOptions)
    fetch('https://thesynergyworks.com/wp-json/custom-cf7/v1/submit/17609', requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.status === 'spam') {
          notification({
            type: 'error',
            title: 'Something went wrong!',
            description: result?.message || 'Unable to submit newsLetter request at the moment. Please try again later.',
          });
        }
        notification({
          type: 'success',
          title: 'Subscription Added!',
          description: result?.message || 'Your subscription has been added for the newsletter.',
        });
      })
      .catch((error) => {
        console.log('error', error);
        notification({
          type: 'error',
          title: 'Unable to submit Info!',
          description: 'Please try again later.',
        });
      })
      .finally(() => setIsLoading(false));
  };

  return { isLoading, submitContactInfo };
};
